'use client';

import {ErrorCollectionContext} from '@dagster-io/ui-components';
import {datadogRum} from '@datadog/browser-rum';
import {ReactNode} from 'react';

export default function LoginAppErrorProvider({children}: {children: ReactNode}) {
  return (
    <ErrorCollectionContext.Provider
      value={{
        errorCollectionMessage: 'This error has been reported to the Dagster team.',
        errorStackIncluded: true,
        onReportError: (error, context) => {
          console.error(error, context);
          datadogRum.addError(error, context);
        },
      }}
    >
      {children}
    </ErrorCollectionContext.Provider>
  );
}
